import { match } from 'path-to-regexp';

import { PageNameV2, route2PVEvent, route2PVEventV2 } from '@/constants/track';

export function getPageEventNameByMapConfig(pathUrl: string, mapConfig: any) {
  let [urlStr = '/'] = pathUrl.split('?');

  const allRoutes = Object.keys(mapConfig);
  const matched = allRoutes.find(route => {
    try {
      const fn = match(route, { decode: decodeURIComponent });
      const res = fn(urlStr);

      return !!res;
    } catch (err) {
      return false;
    }
  });
  return matched ? mapConfig[matched] : '';
}

/**
 * 目前需要新老2套的PV映射关系, 这个是处理老的, 过渡完成后删除
 * @param pathUrl url
 * @returns matched route mapping
 */
export function getPageEventName(pathUrl: string) {
  return getPageEventNameByMapConfig(pathUrl, route2PVEvent);
}
/**
 * 目前需要新老2套的PV映射关系, 这个是处理新的
 * @param pathUrl url
 * @returns matched route mapping
 */
export function getPageEventNameV2(pathUrl: string) {
  return getPageEventNameByMapConfig(pathUrl, route2PVEventV2);
}

export function getMyListPageKey(type) {
  switch (type) {
    case 'bought':
      return PageNameV2.mweb_me_my_bought;
    case 'reorder':
      return PageNameV2.mweb_me_my_reorder;
    case 'watchlist':
      return PageNameV2.mweb_me_my_watch_list;
    case 'recently':
      return PageNameV2.mweb_me_my_recently;
    case 'shareBook':
      return 'mweb_me_my_list';
  }
}
